import React, { useState, useEffect} from 'react';
import "../assets/css/styles.table.css"
import Box from '@mui/material/Box';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { Typography, Modal
} from '@mui/material';
import Layout from './Layout';
import DynamicDataGridComponent from '../components/DynamicDataGrid'
import GridNumberPaging from '../components/GridNumberPaging'
import {useListPOHook} from '../hook/ListPOHook'
import Bindcomponent from '../utils/bindcomponent';
import Helper from './Helper';
import { useNavigate } from 'react-router-dom';

const ListPO = () => {
 const navigate = useNavigate();
  const {message,setmessage,tipe,settipe,getBackgroundColor,getHoverBackgroundColor,columns,rows,rowCountState,paginationModel,onPaginationModelChange,onFilterChange,filterModel,handleSortModelChange,columnVisibilityModel,setColumnVisibilityModel,confirmDelegasiOpen,setConfirmDelegasiOpen,columnsDelegasi,rowsDelegasi} = useListPOHook();
  
  return (
    <>
    <Layout message={message} setmessage={setmessage} tipe={tipe} settipe={settipe}>
    <div className='pd'><b> PROJECT LIST</b></div>
    <div className="pd">
       <div style={{marginBottom:15}}> <button className='btn btn-success' onClick={(e) => navigate(`/ListPOCompleted${Helper.SetReturnUrl()}`) }>Project Completed</button>
    </div>
    <Box sx={{ width: 1 }} >
      <Box sx={{ height: "100%",
        '& .super-app-theme': {
          bgcolor: (theme) =>
            getBackgroundColor(theme.palette.info.main, theme.palette.mode),
          '&:hover': {
            bgcolor: (theme) =>
              getHoverBackgroundColor(theme.palette.info.main, theme.palette.mode),
          },
        },
       }} >
       
      <DataGrid className='fonty'
          columns={columns}
          rows={rows}
          pagination
          rowCount={rowCountState}
          pageSizeOptions={[10]}
          paginationModel={paginationModel}
          paginationMode="server"
          onPaginationModelChange={onPaginationModelChange}
          filterMode="server"
          onFilterModelChange={onFilterChange}

          disableColumnSelector
          disableDensitySelector
          disableColumnFilter
          slots={{ toolbar: GridToolbar }}
          filterModel={filterModel}
        //  onFilterModelChange={(newModel) => setFilterModel(newModel)}
          sortingMode="server"
          onSortModelChange={handleSortModelChange}
          slotProps={{ toolbar: { showQuickFilter: true } }}
          columnVisibilityModel={columnVisibilityModel}
          onColumnVisibilityModelChange={(newModel) =>
            setColumnVisibilityModel(newModel)
          }
          getRowId={(row) => row.id}
          getRowClassName={(params) => 
          {
            if(params.row.nama_client  && params.row.nama_client != "") {
              return "super-app-theme" 
            }
          }
          }
        />
      </Box>
    </Box>
    </div>
 
  <Modal
        open={confirmDelegasiOpen}
        onClose={() => setConfirmDelegasiOpen(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className='modals-delegasi' >
          <Typography id="modal-modal-title" variant="h6" component="h2">
            <h3>Delegation</h3>
          </Typography>
          <Typography id="modal-modal-description">
          <Box sx={{ width: 1 }} >
          <Box sx={{ height: 550 }} >
              <Bindcomponent component='GridNumberPaging'  width="md" customcolumns={columnsDelegasi} rows={rowsDelegasi.map((row) => ({
                ...row,
                id: row.id,  
              }))} name={"delegesigrid"} rowid={"id"}></Bindcomponent>  
             
            </Box>
          </Box>
          </Typography>
        </Box>
  </Modal>
  </Layout>
    </>
  );
};

export default ListPO;